module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AceIF9/tc-custom/9781035809417.jpg?1705766068523",
      "alt": "This image is the cover for the book …On a Donkey Called Elvis"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("…On a Donkey Called Elvis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This book is a panoramic view of the life of one individual growing up in the West of Ireland in the sixties and seventies. It chronicles the advances made by society, its laws and restrictions that were rooted in the past of this Catholic state. It moves from childhood to adolescence and onto adulthood, and describes the events which shaped her life as she grappled with the very many challenges that life throws at her. Neither defeatist nor morbid, this is, for the most part, a light-hearted description of her actions on occasions which are difficult. She takes life on its terms and becomes more confident with each passing incident.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cathy O Malley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Cathy O Malley was born in the West of Ireland and grew up listening to the music of Motown, Rock and Roll and seventies music. The author travelled to the Middle East with her family in the late 1980s and early ’90s and experienced first-hand the Gulf War from her home close by the military airbase there. She lives in The West of Ireland with her dog, Rover!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0